<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <button 
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link :to="'/users/update/' + currentUser.id">
              <p class="nav-link">{{ currentUser.email }}</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click="logout()">
              <i class="ti-logout"></i>
              <p>
                Logout
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div></nav>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from "vuex";
import { LOGOUT } from "@/store/actions.type";
import { API_URL, ASSETS_HOST } from "@/common/config";

export default {
  computed: {
    ...mapGetters([
      "currentUser",
      "isAuthenticated",
    ]),
    
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>
<style>
</style>
